
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Activity, User, CalendarDays } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  
  // Updated mobile navigation with emphasis on cycle tracking
  const navItems = [
    { name: 'Home', path: '/integrated-dashboard', icon: Home },
    { name: 'Cycle', path: '/cycle-tracking', icon: Activity },
    { name: '30-Day Plan', path: '/calendar', icon: CalendarDays },
    { name: 'Profile', path: '/profile', icon: User },
  ];
  
  return (
    <footer className="sticky bottom-0 w-full bg-white border-t border-hormony-beige/50 py-2 z-40 md:hidden">
      <div className="container mx-auto">
        <nav className="flex justify-between items-center px-4">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`flex flex-col items-center justify-center p-1.5 ${
                isActive(item.path)
                  ? 'text-hormony-coral'
                  : 'text-hormony-charcoal/60 hover:text-hormony-charcoal'
              }`}
            >
              <item.icon size={18} />
              <span className="text-[10px] mt-0.5">{item.name}</span>
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
